import { db } from '../utils/configureFirebase';

export const setCandidateAttendance = ({
  session, day, sitting, id, present,
}) => {
  db.collection('candidates')
    .doc(id)
    .update({
      [`attendance.${session}.${day}-${sitting}`]: present,
    })
    .then(() => {
      console.log('attendance updated'); // eslint-disable-line no-console
    })
    .catch((error) => {
      console.log(error); // eslint-disable-line no-console
    });
};

export const setCabinetMeetingAttendance = ({ session, id, present }) => {
  db.collection('candidates')
    .doc(id)
    .update({
      [`attendance.${session}.cabinetMeeting`]: present,
    })
    .then(() => {
      console.log('cabinet meeting attendance updated'); // eslint-disable-line no-console
    })
    .catch((error) => {
      console.log(error); // eslint-disable-line no-console
    });
};

export const setBudgetSeminarAttendance = ({ id, present }) => {
  db.collection('candidates')
    .doc(id)
    .update({
      'attendance.BUDGET.seminarAttendance': present,
    })
    .then(() => {
      console.log('seminar attendance updated'); // eslint-disable-line no-console
    })
    .catch((error) => {
      console.log(error); // eslint-disable-line no-console
    });
};



// WEBPACK FOOTER //
// ./src/services/attendanceServices.js